module.exports = __webpack_public_path__ + "static/media/teamBuilding.fc9ffbbb.png";